import * as yup from "yup";
import { unformat } from "@react-input/number-format";

export default function getFinancialInformationSchema(isNewBusiness) {
    return yup.object({
        personalPercent: yup
            .number()
            .min(0)
            .max(100)
            .required()
            .typeError("Please enter a value between 0 and 100."),
        commercialPercent: yup
            .number()
            .min(0)
            .max(100)
            .required()
            .typeError("Please enter a value between 0 and 100."),
        otherPercent: yup
            .number()
            .min(0)
            .max(100)
            .required()
            .typeError("Please enter a value between 0 and 100."),
        personalAutoCheck: yup.bool().optional(),
        homeCheck: yup.bool().optional(),
        recreationalCheck: yup.bool().optional(),
        commercialAutoCheck: yup.bool().optional(),
        commercialTruckingCheck: yup.bool().optional(),
        generalCheck: yup.bool().optional(),
        otherCheck: yup.bool().optional(),
        personalAutoPremium: yup
            .string()
            .when("personalAutoCheck", {
                is: true,
                then: schema => schema
                    .required("Please enter the Written Premium.")
                    .test('greater-than-threshold', isNewBusiness() ? "Please enter an amount equal to or greater than $100." : "Please enter an amount equal to or greater than $1000.",
                        function (value) {
                            let test = value.replaceAll(/[^0-9.]/g, '');
                            const threshold = isNewBusiness() ? 100 : 1000;
                            return parseFloat(test) >= threshold
                        }
                    ),
            }),
        homePremium: yup
            .string()
            .when("homeCheck", {
                is: true,
                then: schema => schema
                    .required("Please enter the Written Premium.")
                    .test('greater-than-threshold', isNewBusiness() ? "Please enter an amount equal to or greater than $100." : "Please enter an amount equal to or greater than $1000.",
                        function (value) {
                            let test = value.replaceAll(/[^0-9.]/g, '');
                            const threshold = isNewBusiness() ? 100 : 1000;
                            return parseFloat(test) >= threshold
                        }
                    ),
            }),
        recreationalPremium: yup
            .string()
            .when("recreationalCheck", {
                is: true,
                then: schema => schema
                    .required("Please enter the Written Premium.")
                    .test('greater-than-threshold', isNewBusiness() ? "Please enter an amount equal to or greater than $100." : "Please enter an amount equal to or greater than $1000.",
                        function (value) {
                            let test = value.replaceAll(/[^0-9.]/g, '');
                            const threshold = isNewBusiness() ? 100 : 1000;
                            return parseFloat(test) >= threshold
                        }
                    ),
            }),
        commercialAutoPremium: yup
            .string()
            .when("commercialAutoCheck", {
                is: true,
                then: schema => schema
                    .required("Please enter the Written Premium.")
                    .test('greater-than-threshold', isNewBusiness() ? "Please enter an amount equal to or greater than $100." : "Please enter an amount equal to or greater than $1000.",
                        function (value) {
                            let test = value.replaceAll(/[^0-9.]/g, '');
                            const threshold = isNewBusiness() ? 100 : 1000;
                            return parseFloat(test) >= threshold
                        }
                    ),
            }),
        commercialTruckingPremium: yup
            .string()
            .when("commercialTruckingCheck", {
                is: true,
                then: schema => schema
                    .required("Please enter the Written Premium.")
                    .test('greater-than-threshold', isNewBusiness() ? "Please enter an amount equal to or greater than $100." : "Please enter an amount equal to or greater than $1000.",
                        function (value) {
                            let test = value.replaceAll(/[^0-9.]/g, '');
                            const threshold = isNewBusiness() ? 100 : 1000;
                            return parseFloat(test) >= threshold
                        }
                    ),
            }),
        generalPremium: yup
            .string()
            .when("generalCheck", {
                is: true,
                then: schema => schema
                    .required("Please enter the Written Premium.")
                    .test('greater-than-threshold', isNewBusiness() ? "Please enter an amount equal to or greater than $100." : "Please enter an amount equal to or greater than $1000.",
                        function (value) {
                            let test = value.replaceAll(/[^0-9.]/g, '');
                            const threshold = isNewBusiness() ? 100 : 1000;
                            return parseFloat(test) >= threshold
                        }
                    ),
            }),
        otherPremium: yup
            .string()
            .when("otherCheck", {
                is: true,
                then: schema => schema
                    .required("Please enter the Written Premium.")
                    .test('greater-than-threshold', isNewBusiness() ? "Please enter an amount equal to or greater than $100." : "Please enter an amount equal to or greater than $1000.",
                        function (value) {
                            let test = value.replaceAll(/[^0-9.]/g, '');
                            const threshold = isNewBusiness() ? 100 : 1000;
                            return parseFloat(test) >= threshold
                        }
                    ),
            }),
        personalAutoPolicies: yup
            .string()
            .when("personalAutoCheck", {
                is: true,
                then: schema => schema
                    .required("Please enter the Policies in Force.")
                    .test('greater-than-1', "Please enter an amount equal to or greater than 1",
                        function (value) {
                            let test = value.replaceAll(/[^0-9.]/g, '');
                            return parseFloat(test) >= 1
                        }
                    ),
            }),
        homePolicies: yup
            .string()
            .when("homeCheck", {
                is: true,
                then: schema => schema
                    .required("Please enter the Policies in Force.")
                    .test('greater-than-1', "Please enter an amount equal to or greater than 1",
                        function (value) {
                            let test = value.replaceAll(/[^0-9.]/g, '');
                            return parseFloat(test) >= 1
                        }
                    ),
            }),
        recreationalPolicies: yup
            .string()
            .when("recreationalCheck", {
                is: true,
                then: schema => schema
                    .required("Please enter the Policies in Force.")
                    .test('greater-than-1', "Please enter an amount equal to or greater than 1",
                        function (value) {
                            let test = value.replaceAll(/[^0-9.]/g, '');
                            return parseFloat(test) >= 1
                        }
                    ),
            }),
        commercialAutoPolicies: yup
            .string()
            .when("commercialAutoCheck", {
                is: true,
                then: schema => schema
                    .required("Please enter the Policies in Force.")
                    .test('greater-than-1', "Please enter an amount equal to or greater than 1",
                        function (value) {
                            let test = value.replaceAll(/[^0-9.]/g, '');
                            return parseFloat(test) >= 1
                        }
                    ),
            }),
        commercialTruckingPolicies: yup
            .string()
            .when("commercialTruckingCheck", {
                is: true,
                then: schema => schema
                    .required("Please enter the Policies in Force.")
                    .test('greater-than-1', "Please enter an amount equal to or greater than 1",
                        function (value) {
                            let test = value.replaceAll(/[^0-9.]/g, '');
                            return parseFloat(test) >= 1
                        }
                    ),
            }),
        generalPolicies: yup
            .string()
            .when("generalCheck", {
                is: true,
                then: schema => schema
                    .required("Please enter the Policies in Force.")
                    .test('greater-than-1', "Please enter an amount equal to or greater than 1",
                        function (value) {
                            let test = value.replaceAll(/[^0-9.]/g, '');
                            return parseFloat(test) >= 1
                        }
                    ),
            }),
        otherPolicies: yup
            .string()
            .when("otherCheck", {
                is: true,
                then: schema => schema
                    .required("Please enter the Policies in Force.")
                    .test('greater-than-1', "Please enter an amount equal to or greater than 1",
                        function (value) {
                            let test = value.replaceAll(/[^0-9.]/g, '');
                            return parseFloat(test) >= 1
                        }
                    ),
            }),
        insurerOne: yup.string().required("Please select a Company"),
        personalOne: yup
            .string()
            .when("insurerOne", {
                is: (value) => value !== "" && value !== "NA",
                then: () => yup.number()
                    .min(0, "Please enter a value between 0 and 100.")
                    .max(100, "Please enter a value between 0 and 100.")
                    .required()
                    .typeError("Please enter a value between 0 and 100."),
            }),
        commercialOne: yup
            .string()
            .when("insurerOne", {
                is: (value) => value !== "" && value !== "NA",
                then: () => yup.number()
                    .min(0, "Please enter a value between 0 and 100.")
                    .max(100, "Please enter a value between 0 and 100.")
                    .required()
                    .typeError("Please enter a value between 0 and 100."),
            }),
        insurerTwo: yup.string().optional(),
        personalTwo: yup
            .string()
            .when("insurerTwo", {
                is: (value) => value !== "" && value !== "NA",
                then: () => yup.number()
                    .min(0, "Please enter a value between 0 and 100.")
                    .max(100, "Please enter a value between 0 and 100.")
                    .required()
                    .typeError("Please enter a value between 0 and 100."),
                otherwise: () => yup.string().optional()
            }),
        commercialTwo: yup
            .string()
            .when("insurerTwo", {
                is: (value) => value !== "" && value !== "NA",
                then: () => yup.number()
                    .min(0, "Please enter a value between 0 and 100.")
                    .max(100, "Please enter a value between 0 and 100.")
                    .required()
                    .typeError("Please enter a value between 0 and 100."),
                otherwise: () => yup.string().optional()
            }),
        insurerThree: yup.string().optional(),
        personalThree: yup
            .string()
            .when("insurerThree", {
                is: (value) => value !== "" && value !== "NA",
                then: () => yup.number()
                    .min(0, "Please enter a value between 0 and 100.")
                    .max(100, "Please enter a value between 0 and 100.")
                    .required()
                    .typeError("Please enter a value between 0 and 100."),
                otherwise: () => yup.string().optional()
            }),
        commercialThree: yup
            .string()
            .when("insurerThree", {
                is: (value) => value !== "" && value !== "NA",
                then: () => yup.number()
                    .min(0, "Please enter a value between 0 and 100.")
                    .max(100, "Please enter a value between 0 and 100.")
                    .required()
                    .typeError("Please enter a value between 0 and 100."),
                otherwise: () => yup.string().optional()
            })
    })
        .optional();
}
